import { translate as libTranslate } from '@fiverr-private/i18n-react';
import { TranslationKeyWithPrefix } from './types';

export const translate = (key: TranslationKeyWithPrefix, options?: Record<string, unknown>) =>
    libTranslate(`code_activation.${key}`, options);
